import { render, staticRenderFns } from "./navTitle.vue?vue&type=template&id=491ed3fa&scoped=true&"
import script from "./navTitle.vue?vue&type=script&lang=js&"
export * from "./navTitle.vue?vue&type=script&lang=js&"
import style0 from "./navTitle.vue?vue&type=style&index=0&id=491ed3fa&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../layers/paketo-buildpacks_npm-install/build-modules/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "491ed3fa",
  null
  
)

export default component.exports